'use client';

import type { IProductListSection } from './data';

import {
  Box,
  Container,
  Image,
  Pagination,
  ProductCard,
  ProductCount,
  SimpleGrid,
  Stack,
} from '@/components';
import { routes } from '@/statics';

const ProductListSection: React.FC<IProductListSection> = ({
  products,
  pagination,
  bannerImage,
}) => {
  return (
    <Container>
      <ProductCount count={pagination.total || 0} />
      <SimpleGrid
        columns={{ base: 2, lg: 3, xl: 4, '2xl': 5 }}
        marginTop="20px"
        gap={4}
      >
        {bannerImage && (
          <Stack
            flexDir={{ base: 'column', md: 'row' }}
            gap={8}
            alignItems={{ base: 'center', md: 'flex-start' }}
          >
            <Box
              width={{ base: '100%', md: 'full' }}
              aspectRatio="252/422"
              position="relative"
              sx={{
                '& img': {
                  objectFit: 'cover',
                  borderRadius: 'xs',
                },
              }}
            >
              <Image
                src={bannerImage}
                alt={'categoryBanner'}
                fill
                sizes="(min-width: 96em) 272px, (min-width: 90em) 343px, (min-width: 80em) calc((100vw - 68px) / 4), (min-width: 62em) calc((100vw - 52px) / 3), calc((100vw - 36px) / 2)"
              />
            </Box>
          </Stack>
        )}
        {products?.map((product) => (
          <ProductCard
            key={product.id}
            cardData={product}
            link={routes.product.href(product.code)}
          />
        ))}
      </SimpleGrid>
      <Box mt={{ base: '16', md: '32' }}>
        <Pagination
          totalCount={pagination?.total}
          siblingCount={1}
          currentPage={Number(pagination?.current) || 1}
          pageSize={pagination?.page_size || 15}
        />
      </Box>
    </Container>
  );
};
export default ProductListSection;
